import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import InsuranceLoansAnalytics from '@/components/insurance-sub/InsuranceLoansAnalytics';
import InsuranceLoansRecords from '@/components/insurance-sub/InsuranceLoansRecords';
import { Landmark } from 'lucide-react';

export default function InsuranceLoans() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <Landmark className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Premium Years</h1>
                </div>
                {/* THE PAGE IS ABOUT A YEAR OF COVER, NOT A LOAN [D-B46 R9]. Twelve of the estate's
                    308 rows are years the driver paid for in full — nothing was advanced, nothing
                    accrues — and calling every row an advance asserted of those twelve a thing that
                    is false about them. The route stays `/dashboard/insurance/loans`: nothing in the
                    permissions table pins it, and moving it would only break bookmarks. */}
                <p className="text-muted-foreground">Every policy year recorded against a contract — the premium Primelane advanced, and the premium the driver paid in full.</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <InsuranceLoansAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <InsuranceLoansRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
